import { createStore } from '@store/createStore';

const useLocationBlockStore = createStore((set) => ({
  parentLocationId: 0,
  action: {
    setParentLocationId: (parentLocationId) => set({ parentLocationId }),
  },
}));

export const useLocationBlockStoreAction = () => useLocationBlockStore((state) => state.action);

export const selectParentLocationId = () => useLocationBlockStore((state) => state.parentLocationId);
